export default __webpack_public_path__ + "static/media/26M.d2f1a859.jpeg";